module.exports = __webpack_public_path__ + "img/preview.807c5d36.svg";